import { __awaiter, __generator } from "tslib";
import { useEffect, useState, useRef } from 'react';
import { useUtility } from '../utilityReactProvider';
export function useUserProfile(options, shouldReturnObj) {
    var _this = this;
    if (options === void 0) { options = { refetchOnFocus: false }; }
    var componentIsMounted = useRef(true);
    var UserProfile = useUtility().UserProfile;
    var _a = useState(undefined), userProfile = _a[0], setUserProfile = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        if (!UserProfile) {
            throw new Error('The Utility provided does not include UserProfile module, ensure you are using the right version');
        }
        var getUserProfile = function () { return __awaiter(_this, void 0, void 0, function () {
            var uP;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, UserProfile.getUserProfile()];
                    case 1:
                        uP = _a.sent();
                        if (componentIsMounted.current) {
                            setUserProfile(uP);
                            setLoading(false);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var handleRefetchOnFocus = function () { return __awaiter(_this, void 0, void 0, function () {
            var uP;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(document.visibilityState === 'visible')) return [3 /*break*/, 2];
                        if (!componentIsMounted.current) return [3 /*break*/, 2];
                        setLoading(true);
                        UserProfile.clearUserProfile();
                        return [4 /*yield*/, UserProfile.getUserProfile()];
                    case 1:
                        uP = _a.sent();
                        if (componentIsMounted.current) {
                            setUserProfile(uP);
                            setLoading(false);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        getUserProfile();
        if (options.refetchOnFocus) {
            window.addEventListener('visibilitychange', handleRefetchOnFocus, false);
        }
        return function () {
            componentIsMounted.current = false;
            if (options.refetchOnFocus) {
                window.removeEventListener('visibilitychange', handleRefetchOnFocus);
            }
        };
    }, []);
    /**
     * Update the user profile.
     * On success the `userProfile` will be automatically updated
     */
    var updateUserProfile = function (updatedUserProfile) {
        if (!updatedUserProfile || (userProfile === null || userProfile === void 0 ? void 0 : userProfile.id) !== updatedUserProfile.id) {
            return;
        }
        UserProfile.updateUserProfile(updatedUserProfile);
        setUserProfile(UserProfile.getActiveUserProfile());
    };
    if (shouldReturnObj) {
        return {
            userProfile: userProfile,
            isLoading: loading,
            updateUserProfile: updateUserProfile,
        };
    }
    return [userProfile, loading];
}
